import { useGetAllAlertsMutation, useGetMessageCountMutation, useGetRecentAlertsMutation } from './features/authentication/authApiSlice';
import React from 'react';
import PropTypes from 'prop-types';

const globalContext = React.createContext();

export const GlobalProvider = ({ children }) => {
  const [getAllAlerts] = useGetAllAlertsMutation();
  const [getMessageCount] = useGetMessageCountMutation();
  const [getRecentAlerts] = useGetRecentAlertsMutation();
  const [allMessage, setAllMessage] = React.useState([]);
  const [recentAlerts, setRecentAlerts] = React.useState([]);
  const [allMessageCount, setAllMessageCount] = React.useState(null);
  const [notViewedAlerts, setNotViewedAlerts] = React.useState(0);

  async function getAllAlertsAsync(type, sort, text, take = 5, skip = 0) {
    try {
      const allAlertsResponse = await getAllAlerts({
        skip: skip,
        take: take,
        viewType: type,
        orderBy: sort,
        searchText: text
      }).unwrap();
      setAllMessage(() => allAlertsResponse.data);
      return allAlertsResponse.data;
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  }

  async function getMessageCountAsync() {
    try {
      const messageCountResponse = await getMessageCount().unwrap();
      setAllMessageCount(() => messageCountResponse);
      setNotViewedAlerts(() => messageCountResponse.notViewedAlerts);
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  }

  async function getRecentAlertsAsync() {
    try {
      const recentAlertsResponse = await getRecentAlerts().unwrap();
      setRecentAlerts(() => recentAlertsResponse.data);
      return recentAlertsResponse.data;
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  }

  return (
    <globalContext.Provider
      value={{
        allMessage,
        setAllMessage,
        recentAlerts,
        setRecentAlerts,
        getAllAlertsAsync,
        allMessageCount,
        notViewedAlerts,
        setNotViewedAlerts,
        getMessageCountAsync,
        getRecentAlertsAsync
      }}>
      {children}
    </globalContext.Provider>
  );
};

GlobalProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useGlobalContext = () => React.useContext(globalContext);
